<template lang="pug">
.form-group
  label.font-weight-bold OS Version Blacklist
  os-targeting-version-blacklist-object(
    v-for="(item, index) in value",
    :key="index",
    :object="item",
    :index="index",
    @update="updateRule(index, $event)",
    @remove="removeRule(index)"
  )
  div.d-flex.justify-content-center
    i.clickable.la.la-plus-circle(@click="addRule()", style="font-size: 1.5rem;")
</template>

<style lang="scss"></style>

<script>
export default {
  name: 'os-targeting-version-blacklist',
  emits: ['input'],
  props: {
    value: {
      type: [Array],
      required: true,
    },
  },
  methods: {
    addRule() {
      this.$emit('input', [
        ...this.value,
        {
          mode: 'range',
          min: null,
          max: null,
        },
      ]);
    },
    removeRule(index) {
      this.$emit(
        'input',
        this.value.filter((_, i) => i !== index),
      );
    },
    updateRule(index, next) {
      const list = this.value.slice();
      list[index] = next;
      this.$emit('input', list);
    },
  },
};
</script>
